import { render, staticRenderFns } from "./ContactAction.vue?vue&type=template&id=0cc62c80"
import script from "./ContactAction.vue?vue&type=script&lang=js"
export * from "./ContactAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports